<template>
    <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul v-if="orders.length > 0">
            <li v-for="order in orders">
                <inertia-link :href="route('customer.orders.show', order.id)" class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
                    <div class="px-4 py-4 sm:px-6">
                        <div class="flex items-center justify-between">
                            <div class="text-sm leading-5 font-medium text-indigo-600 truncate">
                                Order #{{ order.id }}
                            </div>
                            <div class="ml-2 flex-shrink-0 flex">
                                <span v-if="order.status == 'open'" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">{{ order.status }}</span>
                                <span v-else class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">{{ order.status }}</span>
                            </div>
                        </div>
                        <div class="mt-2 sm:flex sm:justify-between">

                            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0">
                                <svg class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clip-rule="evenodd"/>
                                </svg>
                                <span v-if="order.completed_at">
                                    Completed on <time datetime="2020-01-07">{{ order.completed_at | localDateTime }}</time>
                                </span>
                                <span v-else>
                                    Created on <time datetime="2020-01-07">{{ order.created_at | localDateTime }}</time>
                                </span>
                            </div>
                        </div>
                    </div>
                </inertia-link>
            </li>
        </ul>
        <div v-else class="text-sm text-gray-400 px-4 py-3">
            No orders placed by this customer
        </div>
    </div>
</template>

<script>
  export default {
    name: 'LastTenOrders',

    props: {
      orders: Array
    }
  }
</script>

<style scoped>

</style>